import Icon from "@chakra-ui/icon"
import { Box, Flex, Heading, Link, Text } from "@chakra-ui/layout"

import React from "react"
import PensilRightIcon from "../../assets/pencil-right.svg"

const About = () => {
    return (
        <Box
            w="100%"
            minH="626px"
            bg="_blue"
            mt={["20px", "20px", "50px"]}
            pb={["20px", "20px", "38px"]}
        >
            <Flex
                py={["20px", "40px", "40px", "58px"]}
                pl={["10px", "40px", "40px", "40px", "136px"]}
                justify="space-between"
                align="center"
                w="100%"
                gridGap={["20px", "20px", "40px"]}
                pos="relative"
            >
                <Heading
                    fontSize={["28px", "32px", "48px", "64px", "82px"]}
                    fontWeight="900"
                    color="#fff"
                    // whiteSpace={["unset", "unset", "unset", "unset", "nowrap"]}
                    textTransform="uppercase"
                >
                    О реформи образовања
                </Heading>
                <Flex justify="flex-end">
                    <Icon as={PensilRightIcon} w="100%" h="100%" />
                </Flex>
            </Flex>
            <Flex w="100%" px={["12px", "40px", "40px", "40px", "136px"]} justify="center">
                <Text
                    maxW="1647px"
                    w="100%"
                    fontSize={["16px", "18px", "20px", "22px", "24px"]}
                    color="#fff"
                    css={{ columns: "620px 2" }}
                >
                    <Text as="b"> Знањем мењамо све(т)</Text> нова је национална кампања
                    Министарства просвете, науке и технолошког развоја и Делегације Европске уније у
                    Србији, која се реализује у октобру 2021. године.
                    <br />
                    Циљ кампање је да представи најважније резултате реформе образовања у претходном
                    периоду, кроз примере добре праксе и представљање успеха појединаца који су кроз
                    образовање стекли знања и вештине за остваривање личног и професионалног
                    развоја.
                    <br />
                    Такође, циљ кампање је да јавности приближи стратешке циљеве нове Стратегије
                    развоја образовања до 2030. године, и позове стручну јавност, као и све грађане
                    и грађанке, да допринесу њеној реализацији.  Реформа образовања усмерена је на
                    повећање квалитета образовања и  укључивање сваког детета у процес наставе и
                    учења који су усмерени ка исходима, као и усклађивање образовања  у складу са
                    интересовањима ученика и потребама тржишта рада. 
                    <br />
                    Кампању финансијски подржава Европска унија кроз 
                    <Link
                        fontWeight="bold"
                        fontSize={["16px", "18px", "20px", "22px", "24px"]}
                        textDecoration="underline"
                        target="_self"
                        href={`https://www.euzatebe.rs/rs/projekti/eu-za-reformu-obrazovanja-u-srbiji---redis-2030`}
                        display="inline"
                    >
                        пројекат РЕДИС 2030
                    </Link>
                    . Европска унија, као највећи донатор у Србији, подржава модернизацију система
                    образовања и усклађивање са стандардима и праксама земаља ЕУ. Од 2003. године,
                    ЕУ је донирала више од 100 милиона евра за реформу сектора образовања.
                </Text>
            </Flex>
        </Box>
    )
}

export default About
